<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickClose"
                >
                    Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px;"
        >
            <v-checkbox
                label="Show archived contact cards"
                v-model="include_archived"
                v-if="has_archived"
            />

            <div
                 v-for="(item, index) in results"
                :key="index"
                style="margin-bottom: 25px"
                v-show="showVCard(item)"
            >
                <m-edit-vcard
                    :value="item"
                    v-on:input="update"
                /> 
                    
            <m-text-field
                v-if="action_text != null && text_with_action"
                :label="text_with_action_label"
                :value="item.text"
                v-on:input="onInputText(index, $event)"
                emoji
            />

            <v-btn
                v-if="action_text != null"
                color="primary"
                v-on:click="onClickAction(item)"
            >
                {{action_text}}
            </v-btn>
                    

            </div>


            <m-icon-bar
                v-on:add="onClickAddVCard"
            />

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    props: {
        
        title: {
            type: String,
            default: function() { return 'Edit Contact Card(s)'; }
        },

        action_text: {
            type: String,
            default: function() { return null; }
        },

        text_with_action: {
            type: Boolean,
            default: function() { return false; }
        },

        text_with_action_label: {
            type: String,
            default: function() { return 'Text to send with this contact card'; }
        },
    },

    data() {
        return {
            dialog: false,
            search: {},
            results: [],
            text_with_action_value: null,
            include_archived: false,
        }
    },

    methods: {

        showDialog(search)
        {
            this.search = search;
            this.dialog = true;
            this.include_archived = false;
            this.$router.dialog_guard = this.dialogGuard;

            this.update();
        },

        update()
        {
            this.search['_sort'] = "time_last_modified:asc";
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/vcard',
            
                this.search,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;

                    for ( let i = 0; i < this.results.length; i++ )
                    {
                        this.results[i].text = this.results[i].default_text_to_send_with;
                    }
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to search contact cards');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            // data is valid, so save 
            this.dialog = false;
            next(false);
        },

        onClickClose()
        {
            this.closeDialog();
        },

        onClickAction(item)
        {
            this.closeDialog();
            this.$emit('input', item);
        },

        

        onClickAddVCard()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/vcard/create-stub',
            
                {
                    'organization_id': this.search.organization_id,
                    'for_organization_owned_endpoint': this.search.for_organization_owned_endpoint,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        showVCard(vcard)
        {
            if ( this.include_archived == false && vcard.is_archived == true )
                return false;

            return true;
        },

        onInputText(index, value)
        {
            this.results[index].text = value;
            this.$forceUpdate();
        },
    },

    computed: {
        
        has_archived()
        {
            for ( let i = 0; i < this.results.length; i++ )
            {
                if ( this.results[i].is_archived == true ) 
                    return true;
            }

            return false;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>